'use client';
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/offer.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Loading from "./loading";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import https from "https";
import { useState, useEffect } from "react";
import { Tabs, Tab } from 'react-bootstrap';
import { formatEventDate } from '@/app/utils/formatDate';

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPageData() {
  const query = `
{
  pageData: pageBy(id: "cG9zdDoxMjg=") {
    pageBan {
      bannerText
      bannerSlider {
        desktopImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
    eventsOffersData {
      entertainmentBackgroundImage {
        node {
          mediaItemUrl
        }
      }
      entertainmentCreativeHeading
      entertainmentDescription
      entertainmentFeatured {
        node {
          mediaItemUrl
        }
      }
      entertainmentFeaturedImage {
        node {
          mediaItemUrl
        }
      }
      entertainmentFeaturedTitle
      entertainmentHeading
      entertainmentMainTitle
      overviewCreativeHeading
      overviewHeading
      overviewText
    }
  }
  qleventoffers(first: 50, where: {status: PUBLISH, orderby: {field: DATE, order: DESC}}) {
    nodes {
      title
      eventsOffers {
        startDate
        endDate
        featureImage {
          node {
            mediaItemUrl
          }
        }
      }
      taxoffers {
        nodes {
          slug
          name
        }
      }
      slug
    }
  }
  qlentertainments(first: 50, where: {status: PUBLISH, orderby: {field: DATE, order: DESC}}) {
    nodes {
      title
      entertainment {
        featureImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
  }
  taxoffers(where: {hideEmpty: true}) {
    nodes {
      slug
      name
    }
  }
}
  `;

  const res = await fetch(
    `${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`,
    {
      httpsAgent: agent,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({query}),
      next: {
        revalidate: 60,
      },
    }
  );

  const { data } = await res.json();

  return data;
}

export default function EventsOffers() {

  const deviceType = useDeviceType();

  const [page_data, setPageData] = useState(null);

  const [page_banner_text, setPageBannerText] = useState("");
  const [page_banner_sliders, setPageBannerSliders] = useState([]);

  const [overview_creative_heading, setOverviewCreativeHeading] = useState("");
  const [overview_heading, setOverviewHeading] = useState("");
  const [overview_description, setOverviewDescription] = useState("");

  const [ent_main_title, setEntMainTitle] = useState("");
  const [ent_bg_image, setEntBgImage] = useState("");
  const [ent_creative_heading, setEntCreativeHeading] = useState("");
  const [ent_heading, setEntHeading] = useState("");
  const [ent_description, setEntDescription] = useState("");

  const [ent_featured_image, setEntFeaturedImage] = useState("");
  const [ent_featured_title, setEntFeaturedTitle] = useState("");
  const [ent_featured_file, setEntFeaturedFile] = useState("");

  const [ent_list, setEntList] = useState([]);
  const [ent_all, setEntAll] = useState([]);
  const [type_list, setTypeList] = useState([]);

  const [pre_loader_enabled, setPreLoaderEnable] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const page = await getPageData();
      if(page){
        //console.log(page);
        if(page.pageData){
          setPageData(page.pageData);
          if(page.pageData.pageBan){
            if(page.pageData.pageBan.bannerText){
              setPageBannerText(page.pageData.pageBan.bannerText);
            }
            if(page.pageData.pageBan.bannerSlider){
              setPageBannerSliders(page.pageData.pageBan.bannerSlider);
            }
          }

          if(page.qlentertainments){
            if(page.qlentertainments.nodes){
              setEntList(page.qlentertainments.nodes);      
            }
          }

          if(page.pageData.eventsOffersData){
            if(page.pageData.eventsOffersData.overviewCreativeHeading){
              setOverviewCreativeHeading(page.pageData.eventsOffersData.overviewCreativeHeading);
            }
            if(page.pageData.eventsOffersData.overviewHeading){
              setOverviewHeading(page.pageData.eventsOffersData.overviewHeading);
            }
            if(page.pageData.eventsOffersData.overviewText){
              setOverviewDescription(page.pageData.eventsOffersData.overviewText);
            }

            if(page.pageData.eventsOffersData.entertainmentMainTitle){
              setEntMainTitle(page.pageData.eventsOffersData.entertainmentMainTitle);
            }
            if(page.pageData.eventsOffersData.entertainmentCreativeHeading){
              setEntCreativeHeading(page.pageData.eventsOffersData.entertainmentCreativeHeading);
            }
            if(page.pageData.eventsOffersData.entertainmentHeading){
              setEntHeading(page.pageData.eventsOffersData.entertainmentHeading);
            }
            if(page.pageData.eventsOffersData.entertainmentDescription){
              setEntDescription(page.pageData.eventsOffersData.entertainmentDescription);
            }
            if(page.pageData.eventsOffersData.entertainmentFeaturedTitle){
              setEntFeaturedTitle(page.pageData.eventsOffersData.entertainmentFeaturedTitle);
            }

            if(page.pageData.eventsOffersData.entertainmentBackgroundImage){
              if(page.pageData.eventsOffersData.entertainmentBackgroundImage.node){
                if(page.pageData.eventsOffersData.entertainmentBackgroundImage.node.mediaItemUrl){
                  setEntBgImage(page.pageData.eventsOffersData.entertainmentBackgroundImage.node.mediaItemUrl);
                }
              }
            }

            if(page.pageData.eventsOffersData.entertainmentFeatured){
              if(page.pageData.eventsOffersData.entertainmentFeatured.node){
                if(page.pageData.eventsOffersData.entertainmentFeatured.node.mediaItemUrl){
                  setEntFeaturedFile(page.pageData.eventsOffersData.entertainmentFeatured.node.mediaItemUrl);
                }
              }
            }

            if(page.pageData.eventsOffersData.entertainmentFeaturedImage){
              if(page.pageData.eventsOffersData.entertainmentFeaturedImage.node){
                if(page.pageData.eventsOffersData.entertainmentFeaturedImage.node.mediaItemUrl){
                  setEntFeaturedImage(page.pageData.eventsOffersData.entertainmentFeaturedImage.node.mediaItemUrl);
                }
              }
            }
          }

          if(page.qleventoffers){
            if(page.qleventoffers.nodes){
              setEntAll(page.qleventoffers.nodes);
            }
          }

          if(page.taxoffers){
            if(page.taxoffers.nodes){
              setTypeList(page.taxoffers.nodes);
            }
          }

        }
        setPreLoaderEnable(false);
      }
    };

    fetchData();
    return () => {};
  }, []);

  const settingsent = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    focusOnSelect: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };


  useEffect( () => {
    (
      async () => {
          const LocomotiveScroll = (await import('locomotive-scroll')).default
          const locomotiveScroll = new LocomotiveScroll();
      }
    )()
  }, [])

  if (pre_loader_enabled) {
    return <Loading />;
  }
  return (
    <>
    {page_banner_sliders && page_banner_sliders.length !== 0 &&(
    <section className="inner-banner position-relative">
      <Carousel fade className='page-inner-carousel'>
      {page_banner_sliders.map((banner_img, index) => {

        let imgurl = '';

        if(banner_img.desktopImage){
          if(banner_img.desktopImage.node){
            if(banner_img.desktopImage.node.mediaItemUrl){
              imgurl = banner_img.desktopImage.node.mediaItemUrl;
            }
          }
        }

        return(
        <Carousel.Item key={index}>
          <Image  
            className={styles.banner_section_main_img}
            src={imgurl}
            width={deviceType !== "mobile" ? 1920 : 400}
            height={deviceType !== "mobile" ? 1080 : 800}
            alt="Banner Image"
            priority
            quality={deviceType !== "mobile" ? 100 : 80}
          />
        </Carousel.Item>
        );}
        )}
      </Carousel>
      <div className='inner-banner-text'>
        <h2 className='all-caps section-heading-large section-heading--yellow'>{page_banner_text}</h2>
      </div>
    </section>
    )}
    {page_banner_sliders && page_banner_sliders.length === 0 &&(
    <section className="bg-dark-green green-mesh  inner-banner-text-wrap position-relative">
      <div className='inner-banner-text'>
        <h2 className='all-caps section-heading-large section-heading--yellow m-0'>{page_banner_text}</h2>
      </div>
    </section>
    )}
    <section className="section-padding-top section-padding-bottom bg-dark-green green-mesh ">
      <div className="lsmall-wrap z-top d-flex flex-wrap justify-content-between">
        <div className="half-div half-div-tab-full">
          <h6 className="creative-heading-small creative-heading--white">
          {overview_creative_heading}
          </h6>
          <h1
          className="section-heading section-heading--yellow heading-padding">
          {overview_heading}
          </h1>
        </div>
        <div className="half-div half-div-tab-full">
          <p className="paragraph paragraph--white ">
         {overview_description}
            </p>
        </div>
      </div>
    </section>
    <section className="section-padding-bottom bg-dark-green green-mesh ">
      <div className="main-wrapper z-top">
        <Tabs defaultActiveKey="all" id="offer-tabs" className="offer-tabs">
          <Tab eventKey="all" title="All">
            <div className="">
              <div className={`d-flex flex-wrap justify-content-center ${styles.offer_inner_box_list}`}>
                {ent_all.map((all_item, index) => {

                  let imgurl = "";
                  let typetag = [];
                  let start_date = "";
                  let end_date = "";
                  let page_slug = "";

                  if(all_item.eventsOffers){
                    if(all_item.eventsOffers.featureImage){
                      if(all_item.eventsOffers.featureImage.node){
                        if(all_item.eventsOffers.featureImage.node.mediaItemUrl){
                          imgurl = all_item.eventsOffers.featureImage.node.mediaItemUrl;
                        }
                      }
                    }
                    if(all_item.eventsOffers.startDate){
                      start_date = all_item.eventsOffers.startDate;
                    }
                    if(all_item.eventsOffers.endDate){
                      end_date = all_item.eventsOffers.endDate;
                    }
                  }

                  if(all_item.taxoffers){
                    if(all_item.taxoffers.nodes){
                      if(all_item.taxoffers.nodes){
                        typetag = all_item.taxoffers.nodes.map(node => node.name);
                      }
                    }
                  }

                  const eventDateText = formatEventDate(start_date, end_date);

                  const truncatedTitle =
                            all_item.title.length > 150
                            ? `${all_item.title.substring(0, 150)}[...]`
                            : all_item.title;

                return(
                <div className={styles.offer_inner_box_wrap} key={index}>
                  <div className={styles.offer_inner_box}>
                    <Link
                    href={`/events-and-offers/${all_item.slug}`}
                    className={styles.offer_inner_box__img}>
                      <Image  
                        src={imgurl}
                        width={deviceType !== "mobile" ? 525 : 360}
                        height={deviceType !== "mobile" ? 400 : 400}
                        alt="Banner Image"
                        quality={deviceType !== "mobile" ? 100 : 80}
                      />
                      {(typetag.length !== 0) &&(
                      <div className={styles.offer_box_right_tag_wrap}>
                      { typetag.map((name, index) => (
                        <div className={styles.offer_box_right_tag} key={index}>
                          {name}
                        </div>
                        ))}
                      </div>
                      )}
                    </Link>
                    <div className={styles.offer_inner_box__content} key={index}>
                        <p className="paragraph-xsmall paragraph--white m-0">{eventDateText}</p>
                        <h6 className="creative-heading creative-heading--yellow heading-padding">{truncatedTitle}</h6>
                        <Link className="next-btn next-btn--yellow"
                        href={`/events-and-offers/${all_item.slug}`}
                        >
                          <span className="next-btn--text">more details</span>
                          <div className="next-btn--bottom">
                            <span className="next-btn--bottom-line"></span>
                            <span className="next-btn--bottom-square"></span>
                            <span className="next-btn--bottom-line"></span>
                          </div>
                        </Link>
                    </div>
                  </div>
                </div>
                );}
                )}
              </div>
            </div>
          </Tab>
          {type_list.map((type_item, index) => {

            let filteredarray = [];

            filteredarray = ent_all.filter(item => item.taxoffers.nodes.some(node => node.slug === type_item.slug));
            
          return(
          <Tab eventKey={type_item.slug} title={type_item.name} key={index}>
            <div className="main-wrapper ">
              <div className={`d-flex flex-wrap justify-content-center ${styles.offer_inner_box_list}`}>
                {filteredarray.length !== 0 && filteredarray.map((all_item, indexi) => {

                  let imgurl = "";
                  let typetag = [];
                  let start_date = "";
                  let end_date = "";
                  let page_slug = "";

                  if(all_item.eventsOffers){
                    if(all_item.eventsOffers.featureImage){
                      if(all_item.eventsOffers.featureImage.node){
                        if(all_item.eventsOffers.featureImage.node.mediaItemUrl){
                          imgurl = all_item.eventsOffers.featureImage.node.mediaItemUrl;
                        }
                      }
                    }
                    if(all_item.eventsOffers.startDate){
                      start_date = all_item.eventsOffers.startDate;
                    }
                    if(all_item.eventsOffers.endDate){
                      end_date = all_item.eventsOffers.endDate;
                    }
                  }

                  if(all_item.taxoffers){
                    if(all_item.taxoffers.nodes){
                      if(all_item.taxoffers.nodes){
                        typetag = all_item.taxoffers.nodes.map(node => node.name);
                      }
                    }
                  }

                  const eventDateText = formatEventDate(start_date, end_date);

                  const truncatedTitle =
                            all_item.title.length > 150
                            ? `${all_item.title.substring(0, 150)}[...]`
                            : all_item.title;

                return(
                <div className={styles.offer_inner_box_wrap} key={indexi}>
                  <div className={styles.offer_inner_box}>
                    <Link
                    href={`/events-and-offers/${all_item.slug}`}
                    className={styles.offer_inner_box__img}>
                      <Image  
                        src={imgurl}
                        width={deviceType !== "mobile" ? 500 : 360}
                        height={deviceType !== "mobile" ? 400 : 400}
                        alt="Banner Image"
                        quality={deviceType !== "mobile" ? 100 : 80}
                      />
                      {(typetag.length !== 0) &&(
                      <div className={styles.offer_box_right_tag_wrap}>
                      { typetag.map((name, index) => (
                        <div className={styles.offer_box_right_tag} key={index}>
                          {name}
                        </div>
                        ))}
                      </div>
                      )}
                    </Link>
                    <div className={styles.offer_inner_box__content}>
                        <p className="paragraph-xsmall paragraph--white m-0">{eventDateText}</p>
                        <h6 className="creative-heading creative-heading--yellow heading-padding">{truncatedTitle}</h6>
                        <Link className="next-btn next-btn--yellow"
                        href={`/events-and-offers/${all_item.slug}`}
                        >
                          <span className="next-btn--text">more details</span>
                          <div className="next-btn--bottom">
                            <span className="next-btn--bottom-line"></span>
                            <span className="next-btn--bottom-square"></span>
                            <span className="next-btn--bottom-line"></span>
                          </div>
                        </Link>
                    </div>
                  </div>
                </div>
                );}
                )}
                {filteredarray.length === 0 &&(
                <div>
                    <p className="paragraph paragraph--white">No {type_item.name}</p>
                </div>
                )}
              </div>
            </div>
          </Tab>
          );})}
        </Tabs>
      </div>
    </section>
    <section className="section-padding-bottom section-padding-top bg-dark-green green-mesh  position-relative">
        <div className={styles.drink_bg_img_wrap}>
          <Image  
              className={`w-100 ${styles.drink_bg_img}`}
              src={ent_bg_image}
              width={deviceType !== "mobile" ? 1920 : 360}
              height={deviceType !== "mobile" ? 1080 : 400}
              alt="Banner Image"
              quality={deviceType !== "mobile" ? 100 : 100}
            />
        </div>
        <div className="main-wrapper text-center section-padding-bottom">
          <h2 className="all-caps section-heading-large section-heading--yellow">{ent_main_title}</h2>
        </div>
        <div className='middle-wrap flex-wrap d-flex justify-content-between z-top position-relative'>
          <div className='half-div  half-div-mobile-padding d-flex align-items-center'>
            <div>
              <h6 className="creative-heading-small tab-text-left creative-heading--white">
             {ent_creative_heading}
              </h6>
              <h2
              className="section-heading tab-text-left section-heading--yellow heading-padding">
              {ent_heading}
              </h2>
              <p className="paragraph paragraph--white tab-text-left">
            {ent_description}
              </p>
            </div>
          </div>
          <div className='half-div '>
            <div className='position-relative'>
              <Image  
                className={`w-100 ${styles.dine_welcome_img}`}
                src={ent_featured_image}
                width={deviceType !== "mobile" ? 560 : 360}
                height={deviceType !== "mobile" ? 700 : 400}
                alt="Banner Image"
                quality={deviceType !== "mobile" ? 100 : 80}
              />
              <div className={styles.drink_feature_text}>
                <div>
                  <h2
                  className="creative-heading-large creative-heading--yellow heading-padding">
                   {ent_featured_title}
                  </h2> 
                  <a
                    target="_blank"
                    className={`${styles.download_menu} next-btn next-btn--yellow m-auto`}
                    href={ent_featured_file}
                  >
                    <Image  
                      src="/down-arrow.png"
                      width={50}
                      height={50}
                      alt="Down arrow"
                    />
                    <span>download calender</span>
                    <div className="next-btn--bottom">
                      <span className="next-btn--bottom-line"></span>
                      <span className="next-btn--bottom-square"></span>
                      <span className="next-btn--bottom-line"></span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-padding-bottom bg-dark-green green-mesh  position-relative overflow-hidden">
        <div className={styles.entertain_slider}>
          <Slider className="ent-slider offer-inner-slider z-top" {...settingsent}>
            {ent_list.map((ent_item, index) => {

              let imgurl = "";

              if(ent_item.entertainment){
                if(ent_item.entertainment.featureImage){
                  if(ent_item.entertainment.featureImage.node){
                    if(ent_item.entertainment.featureImage.node.mediaItemUrl){
                      imgurl = ent_item.entertainment.featureImage.node.mediaItemUrl;
                    }
                  }
                }
              }

            return(
            <div key={index}>
              <div className={styles.entertain_slider_div_wrap}>
                <div className={styles.entertain_slider_div}>
                  <Image  
                    src={imgurl}
                    width={deviceType !== "mobile" ? 680 : 350}
                    height={deviceType !== "mobile" ? 750 : 350}
                    alt="entertainment image"
                    quality={90}
                  />
                  <div className={styles.entertain_slider_div_text}>
                    <h6 className="paragraph-small paragraph--yellow all-caps para-bold">
                      {ent_item.title}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            );}
            )}
          </Slider>
        </div>
      </section>
    </>
  )
}
